export default "assets/images/logo-full-e900c7eb.svg";